import PurchaseAssistanceView from './PurchaseAssistanceView';
export default PurchaseAssistanceView;
